/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * **SUCCESS**  All tasks have been processed and the Booking and Lot are currently in sync.  **PROCESSING**  In this state the Lot\'s aren\'t in sync and our task server will process the updates ASAP.  **ERROR**  There has been an error processing the updates and the task server will retry shortly.  **FAILURE**  The task server has hit it\'s attempt limit and cannot process the Lot/Booking. This will need to be looked into and fixed manually by a developer.  * `NEW` - New * `IGNORE` - Ignore * `PROCESSING` - Processing * `SUCCESS` - Success * `ERROR` - Error * `FAILURE` - Failure
 * @export
 * @enum {string}
 */
export enum TritonBookingMetadataLatestTaskStatusEnum {
    New = 'NEW',
    Ignore = 'IGNORE',
    Processing = 'PROCESSING',
    Success = 'SUCCESS',
    Error = 'ERROR',
    Failure = 'FAILURE'
}



